import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from 'src/infra/stores/store';

export interface DeleteModeState {
  enable: boolean;
}

const initialState: DeleteModeState = {
  enable: false,
};

export const DELETE_MODE_KEY = 'deleteMode';

export const deleteModeSlice = createSlice({
  name: DELETE_MODE_KEY,
  initialState,
  reducers: {
    setDeleteMode: (state, action: PayloadAction<boolean>) => {
      state.enable = action.payload;
    },
  },
});

export const { setDeleteMode } = deleteModeSlice.actions;

export const selectDeleteMode = (state: IRootState) => state.deleteMode.enable;

export default deleteModeSlice.reducer;
